// @flow
import { actions as EditProfileActions, initialState as EditProfileInitialState } from './edit-profile/duck';
import { actions as NotificationsActions, initialState as NotificationsInitialState } from './notifications/duck';
import { actions as SavedAddressesActions, initialState as SavedAddressesInitialState } from './saved-addresses/duck';
import { actions as PayoutsActions, initialState as PayoutsInitialState } from './payouts/duck';
import { actions as PaymentsActions, initialState as PaymentsInitialState } from './payments/duck';
import { actions as SecurityActions, initialState as SecurityInitialState } from './security/duck';
import { actions as PasswordActions, initialState as PasswordInitialState } from './password/duck';
import EditProfileReducer from './edit-profile/duck';
import NotificationsReducer from './notifications/duck';
import SavedAddressesReducer from './saved-addresses/duck';
import SecurityReducer from './security/duck';
import PasswordReducer from './password/duck';
import PayoutsReducer from './payouts/duck';
import PaymentsReducer from './payments/duck';

import type { EditProfileState, EditProfileAction } from './edit-profile/duck';
import type { NotificationsState, NotificationsAction } from './notifications/duck';
import type { SavedAddressesState, SavedAddressesAction } from './saved-addresses/duck';
import type { SecurityState, SecurityAction } from './security/duck';
import type { PasswordState, PasswordAction } from './password/duck';
import type { PayoutsState, PayoutsAction } from './payouts/duck';
import type { PaymentsState, PaymentsAction } from './payments/duck';

type PreferencesAction = {
  +type: string;
};

export type PreferencesState = {
  editProfile: EditProfileState;
  notifications: NotificationsState;
  savedAddresses: SavedAddressesState;
  security: SecurityState;
  password: PasswordState;
  payouts: PayoutsState;
  payments: PaymentsState;
};

// Action creators
export const initialState = {
  editProfile: EditProfileInitialState,
  notifications: NotificationsInitialState,
  savedAddresses: SavedAddressesInitialState,
  security: SecurityInitialState,
  password: PasswordInitialState,
  payouts: PayoutsInitialState,
  payments: PaymentsInitialState,
};

//Reducer
export default function reducer(state: PreferencesState = initialState,
                                action: PreferencesAction | EditProfileAction | NotificationsAction |
                                  SavedAddressesAction | SecurityAction | PasswordAction | PayoutsAction | PaymentsAction): PreferencesState {
  switch (action.type) {
    case EditProfileActions.EDIT_PROFILE_PUT_PROFILE_REQUEST:
    case EditProfileActions.EDIT_PROFILE_PUT_PROFILE_SUCCESS:
    case EditProfileActions.EDIT_PROFILE_PUT_PROFILE_ERROR:
    case EditProfileActions.EDIT_PROFILE_PUT_IMAGE_REQUEST:
    case EditProfileActions.EDIT_PROFILE_PUT_IMAGE_SUCCESS:
    case EditProfileActions.EDIT_PROFILE_PUT_IMAGE_ERROR:
      return {
        ...state,
        editProfile: EditProfileReducer(state.editProfile, (action: any)),
      };
    case NotificationsActions.NOTIFICATIONS_GET_NOTIFICATIONS_REQUEST:
    case NotificationsActions.NOTIFICATIONS_GET_NOTIFICATIONS_SUCCESS:
    case NotificationsActions.NOTIFICATIONS_GET_NOTIFICATIONS_ERROR:
    case NotificationsActions.NOTIFICATIONS_PUT_NOTIFICATIONS_REQUEST:
    case NotificationsActions.NOTIFICATIONS_PUT_NOTIFICATIONS_SUCCESS:
    case NotificationsActions.NOTIFICATIONS_PUT_NOTIFICATIONS_ERROR:
      return {
        ...state,
        notifications: NotificationsReducer(state.notifications, (action: any)),
      };
    case SavedAddressesActions.SAVED_ADDRESSES_FETCH_ADDRESSES_REQUEST:
    case SavedAddressesActions.SAVED_ADDRESSES_FETCH_ADDRESSES_SUCCESS:
    case SavedAddressesActions.SAVED_ADDRESSES_FETCH_ADDRESSES_ERROR:
    case SavedAddressesActions.SAVED_ADDRESSES_POST_ADDRESS_REQUEST:
    case SavedAddressesActions.SAVED_ADDRESSES_POST_ADDRESS_SUCCESS:
    case SavedAddressesActions.SAVED_ADDRESSES_POST_ADDRESS_ERROR:
    case SavedAddressesActions.SAVED_ADDRESSES_PUT_ADDRESS_REQUEST:
    case SavedAddressesActions.SAVED_ADDRESSES_PUT_ADDRESS_SUCCESS:
    case SavedAddressesActions.SAVED_ADDRESSES_PUT_ADDRESS_ERROR:
    case SavedAddressesActions.SAVED_ADDRESSES_DELETE_ADDRESS_REQUEST:
    case SavedAddressesActions.SAVED_ADDRESSES_DELETE_ADDRESS_SUCCESS:
    case SavedAddressesActions.SAVED_ADDRESSES_DELETE_ADDRESS_ERROR:
      return {
        ...state,
        savedAddresses: SavedAddressesReducer(state.savedAddresses, (action: any)),
      };
    case SecurityActions.SECURITY_PUT_EMAIL_REQUEST:
    case SecurityActions.SECURITY_PUT_EMAIL_SUCCESS:
    case SecurityActions.SECURITY_PUT_EMAIL_ERROR:
    case SecurityActions.SECURITY_POST_PHONE_REQUEST:
    case SecurityActions.SECURITY_POST_PHONE_SUCCESS:
    case SecurityActions.SECURITY_POST_PHONE_ERROR:
    case SecurityActions.SECURITY_POST_CODE_REQUEST:
    case SecurityActions.SECURITY_POST_CODE_SUCCESS:
    case SecurityActions.SECURITY_POST_CODE_ERROR:
      return {
        ...state,
        security: SecurityReducer(state.security, (action: any)),
      };

    case PasswordActions.PASSWORD_PUT_PASSWORD_REQUEST:
    case PasswordActions.PASSWORD_PUT_PASSWORD_SUCCESS:
    case PasswordActions.PASSWORD_PUT_PASSWORD_ERROR:
      return {
        ...state,
        password: PasswordReducer(state.password, (action: any)),
      };
    case PayoutsActions.PAYOUT_FETCH_PAYOUTS_REQUEST:
    case PayoutsActions.PAYOUT_FETCH_PAYOUTS_SUCCESS:
    case PayoutsActions.PAYOUT_FETCH_PAYOUTS_ERROR:
    case PayoutsActions.PAYOUT_POST_PAYOUT_REQUEST:
    case PayoutsActions.PAYOUT_POST_PAYOUT_SUCCESS:
    case PayoutsActions.PAYOUT_POST_PAYOUT_ERROR:
    case PayoutsActions.PAYOUT_POST_PAYOUT_PAY_PAL_REQUEST:
    case PayoutsActions.PAYOUT_POST_PAYOUT_PAY_PAL_SUCCESS:
    case PayoutsActions.PAYOUT_POST_PAYOUT_PAY_PAL_ERROR:
    case PayoutsActions.PAYOUT_DELETE_PAYOUT_REQUEST:
    case PayoutsActions.PAYOUT_DELETE_PAYOUT_SUCCESS:
    case PayoutsActions.PAYOUT_DELETE_PAYOUT_ERROR:
      return {
        ...state,
        payouts: PayoutsReducer(state.payouts, (action: any)),
      };
    case PaymentsActions.PAYMENT_FETCH_PAYMENTS_REQUEST:
    case PaymentsActions.PAYMENT_FETCH_PAYMENTS_SUCCESS:
    case PaymentsActions.PAYMENT_FETCH_PAYMENTS_ERROR:
    case PaymentsActions.PAYMENT_POST_PAYMENT_REQUEST:
    case PaymentsActions.PAYMENT_POST_PAYMENT_SUCCESS:
    case PaymentsActions.PAYMENT_POST_PAYMENT_ERROR:
    case PaymentsActions.PAYMENT_PUT_PAYMENT_REQUEST:
    case PaymentsActions.PAYMENT_PUT_PAYMENT_SUCCESS:
    case PaymentsActions.PAYMENT_PUT_PAYMENT_ERROR:
    case PaymentsActions.PAYMENT_DELETE_PAYMENT_REQUEST:
    case PaymentsActions.PAYMENT_DELETE_PAYMENT_SUCCESS:
    case PaymentsActions.PAYMENT_DELETE_PAYMENT_ERROR:
      return {
        ...state,
        payments: PaymentsReducer(state.payments, (action: any)),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/preferences/duck.js